import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

export const InfoBar = ({ children, sideClass, className }) => {
  return (
    <div className={classNames('info-bar d-flex', className)}>
      <span className={classNames('info-bar__left', sideClass)}></span>
      {children}
    </div>
  );
};

InfoBar.propTypes = {
  children: PropTypes.node,
  sideClass: PropTypes.string,
  className: PropTypes.string,
};
